var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4006 13.8333L6.23389 9.66658L7.40055 8.45825L9.56722 10.6249V3.83325H11.2339V10.6249L13.4006 8.45825L14.5672 9.66658L10.4006 13.8333ZM5.40055 17.1666C4.94222 17.1666 4.54986 17.0034 4.22347 16.677C3.89708 16.3506 3.73389 15.9583 3.73389 15.4999V12.9999H5.40055V15.4999H15.4006V12.9999H17.0672V15.4999C17.0672 15.9583 16.904 16.3506 16.5776 16.677C16.2512 17.0034 15.8589 17.1666 15.4006 17.1666H5.40055Z",
    fill: "#484646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download_2.7752d86b3483bf5e0f9af867d2d23052.svg";
export { ForwardRef as ReactComponent };